module.exports = __webpack_public_path__ + "static/media/logo.a097f1a5.svg";